import type { ApiClient } from "@carepass/api-client";
import type { Schemas } from "../workspace/api.generated";

export async function getIpAllowlist(api: ApiClient, signal?: AbortSignal) {
  return (await api.get<Array<Schemas["AdminIpAllowlistResponse"]>>("/api/v1/admin/admin-ip-allowlist", {
    signal,
    cache: "no-store",
  })).data;
}

export async function createIpAllowlistEntry(api: ApiClient, body: Schemas["CreateAdminIpAllowlistRequest"], signal?: AbortSignal) {
  return (await api.post<Schemas["AdminIpAllowlistResponse"], Schemas["CreateAdminIpAllowlistRequest"]>("/api/v1/admin/admin-ip-allowlist", body, {
    signal,
    cache: "no-store",
  })).data;
}

export async function deactivateIpAllowlistEntry(api: ApiClient, id: number, signal?: AbortSignal) {
  await api.post<void, undefined>(`/api/v1/admin/admin-ip-allowlist/${id}/deactivate`, undefined, {
    signal,
    cache: "no-store",
  });
}
